import { degToRad } from 'components/_utils/mathUtils'
import tempDialConstants from 'components/Phantom/TempDial/TempDial.constants'

const { MIN_TEMP, MAX_TEMP, CIRCLE_X, CIRCLE_Y, CIRCLE_R, CIRCUMFERENCE, BASE_CIRCLE_SWEEP } = tempDialConstants

export const getStartingTempType = (startTemp: number, endTemp: number) => {
	const midpoint = (MIN_TEMP + MAX_TEMP) / 2

	if (startTemp === midpoint) {
		return endTemp >= midpoint ? 'warm' : 'cold'
	}

	return startTemp > midpoint ? 'warm' : 'cold'
}

/**
 * Updates the SVG elements to reflect the temperature reading
 * @param tempReading Temperature mapped to a range of -1 to 1, with -1 being `MIN_TEMP` and 1 being `MAX_TEMP`
 * @param maskID ID of the mask element
 * @param tipID ID of the tip element
 */
export const updateSVG = (tempReading: number, maskID: string, tipID: string) => {
	const temperatureSweep = (BASE_CIRCLE_SWEEP / 2) * Math.abs(tempReading)

	const temperatureDashArray = `${CIRCUMFERENCE * temperatureSweep} ${CIRCUMFERENCE * (1 - temperatureSweep)}`
	const temperatureRotation = 270 - (tempReading < 0 && 360 * temperatureSweep)

	const tipAngle = degToRad(270 + (360 * BASE_CIRCLE_SWEEP * tempReading) / 2)
	const tipX = CIRCLE_X + Math.cos(tipAngle) * CIRCLE_R
	const tipY = CIRCLE_Y + Math.sin(tipAngle) * CIRCLE_R

	const mask = document.getElementById(maskID)
	const tip = document.getElementById(tipID)

	if (!mask || !tip) return

	mask.setAttribute('stroke-dasharray', temperatureDashArray)
	mask.setAttribute('transform', `rotate(${temperatureRotation} ${CIRCLE_X} ${CIRCLE_Y})`)
	tip.setAttribute('cx', tipX.toString())
	tip.setAttribute('cy', tipY.toString())
}
